module.exports = __webpack_public_path__ + "static/media/truck-plow.74b3d9db.svg";